export default {
    methods: {
        onAddImg(e) {
            if (window.$(e.target).hasClass('uploaded')) return
            window
                .$(e.target)
                .parents('.js-upload-img-wrap')
                .find('input[type=file]')
                .click()
        },
        gotoStep(stepNum) {
            window.$('.product-form').addClass('hide')
            window.$('.product-form.step' + stepNum).removeClass('hide')
        },
        onImgInputChange(e) {
            const input = e.target
            const size = input.files[0].size / 1024 / 1024
            if (size < 2) {
                const reader = new FileReader()
                reader.onload = () => {
                    const dataURL = reader.result

                    // console.log(dataURL);
                    // console.log(input.files[0].name);

                    var img = window
                        .$(e.target)
                        .parents('.js-upload-img-wrap')
                        .find('.js-upload-img')

                    window
                        .$(img)
                        .addClass('uploaded')
                        .css({
                            background:
                                'url(' + dataURL + ') no-repeat center center',
                            'background-size': 'contain'
                        })

                    window
                        .$(e.target)
                        .parents('.js-upload-img-wrap')
                        .find('.js-uploaded-img-btn')
                        .removeClass('hide')
                }
                reader.readAsDataURL(input.files[0])
            } else {
                console.log(
                    input.files[0].name + ' Too long file size ' + size + ' mb'
                )
            }
        },
        jqForm() {
            window.$('.select--product-form').selectpicker({
                width: '100%',
                title: ' '
            })
            window.$('.select--product-price').selectpicker({
                width: '100%',
                title: 'за штуку'
            })

            var radiobtns = window.$('.product-form input[type=radio]')

            window.$(radiobtns).on('change', function() {
                var formBtn = window
                    .$(this)
                    .parents('form')
                    .find('.product-form__btn')
                window.$(formBtn).removeAttr('disabled')
            })

            var defaultBg = {
                background:
                    '#F3F3F5 url(img/icons/plus.svg) no-repeat center center',
                'background-size': '16px 16px'
            }

            window.$('.cabinet-btn--remove-img').on('click', function() {
                window
                    .$(this)
                    .siblings('.product-form__img')
                    .css(defaultBg)
                window.$(this).addClass('hide')
            })

            window.$('.cabinet-btn--edit-img').on('click', function() {
                window
                    .$(this)
                    .parents('.js-upload-img-wrap')
                    .find('input[type=file]')
                    .click()
            })
        }
    }
}
